import { Component, OnInit } from '@angular/core';
import { HotparkingService } from '../../services';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-pub-hot-parking',
    templateUrl: './pub-hot-parking.component.html',
    styleUrls: ['./pub-hot-parking.component.css']
})
export class PubHotParkingComponent implements OnInit {
    serialNumber: string;
    licensePlate: string;

    constructor(
        private hotParkingService: HotparkingService,
        private messageService: MessageService
    ) { }

    ngOnInit() {
    }

    addHotParkingPosition() {
        this.hotParkingService.addPubHotParkingCard(this.serialNumber, this.licensePlate).subscribe(
            () => {
                this.serialNumber = '';
                this.licensePlate = '';
                this.messageService.add({ severity: 'success', summary: 'Karta dodana', detail: 'Dodano użytkownika do listy Hot Parking' });
            },
            (error) => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Karta nie została dodana do listy Hot Parking', detail: error.error.exception.message });
            }
        );
    }

    deleteHotParkingPosition() {
        this.hotParkingService.deletePubHotParkingCard(this.serialNumber, this.licensePlate).subscribe(
            () => {
                this.serialNumber = '';
                this.licensePlate = '';
                this.messageService.add({ severity: 'success', summary: 'Karta usunięta', detail: 'Karta została usunięta z listy Hot Parking' });
            },
            error => {
                console.error(error);
                this.messageService.add({ severity: 'error', summary: 'Błąd usuwania karty', detail: 'Karta nie została usunięta z listy Hot Parking' });
            }
        );
    }
}
